<template>
  <main>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Riwayat Pesanan</h4>
      </div>
      <div class="card-body">
        <div class="">
          <ul class="verti-timeline list-unstyled">
            <li
              :class="
                index == orderTimeline.length - 1
                  ? 'event-list active'
                  : 'event-list'
              "
              v-for="(ot, index) in orderTimeline"
              :key="index"
            >
              <div class="event-timeline-dot">
                <i
                  :class="
                    index == orderTimeline.length - 1
                      ? 'fa basicOrder fa-arrow-circle-o-right animatedXfade'
                      : 'fa fa-arrow-circle-o-right text-muted'
                  "
                ></i>
              </div>
              <div class="media">
                <div class="me-3 mb-3 mt-1">
                  <i
                    :class="
                      ot.title == 'Pesanan Baru'
                        ? 'fa h4-icon fa-copy text-primary'
                        : ot.title == 'Diproses'
                        ? 'fa h4-icon fa-truck-loading text-primary'
                        : ot.title == 'Dikirim'
                        ? 'fa h4-icon fa-shipping-fast text-primary'
                        : ot.title == 'Sampai'
                        ? 'fa h4-icon fa-map-marker-alt text-primary'
                        : ot.title == 'Diterima'
                        ? 'fa h4-icon fa-copy text-primary'
                        : ot.title == 'Dibayar'
                        ? 'fa h4-icon fa-clipboard-check text-primary'
                        : 'fab h4-icon fa-buffer text-primary'
                    "
                  ></i>
                </div>
                <div class="media-body">
                  <div>
                    <h5>{{ ot.title }}</h5>
                    <p class="text-muted fs-13">{{ ot.text }}</p>
                    <span class="text-muted fs-13"
                      >Hari: {{ ot.createdAt }}</span
                    >
                    <br />
                    <span class="text-muted fs-13">Jam: {{ ot.timeAt }}</span>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list" v-if="statusDibatalkan.isActive">
              <div class="event-timeline-dot">
                <i
                  id="canceledOrder"
                  class="fa fa-arrow-circle-o-right text-muted"
                ></i>
              </div>
              <div class="media">
                <div class="me-3 mb-3 mt-1">
                  <i
                    class="
                      fa
                      h4-icon
                      fa-times-circle
                      v-timeline-icon v-last
                      text-danger
                    "
                  ></i>
                </div>
                <div class="media-body">
                  <div>
                    <h5>{{ statusDibatalkan.title }}!</h5>
                    <p class="text-muted fs-13">
                      <!-- {{ statusDibatalkan.subTitle }} -->
                      {{ rejectReason ? rejectReason : "Pesanan Dibatalkan" }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="isTracking" class="card">
      <div class="card-header">
        <h4 class="card-title">Tracking Order</h4>
      </div>
      <div class="card-body">
        <button
          :disabled="isFetching"
          class="btn btn-primary btn-sm col-md"
          @click="openTracking"
        >
          <span v-if="!isFetching">Order Tracking</span>
          <i :hidden="!isFetching" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <div class="col-md-12 mt-5 mb-5">
          <!-- <content-placeholders
            id="orderTrackingPlaceholder"
            style="display: none"
          >
            <content-placeholders-heading :img="true" />
            <content-placeholders-text :lines="3" />
          </content-placeholders> -->
        </div>
        <template v-if="isOpenTracking" class="text-center">
          No Resi :
          <p class="text-muted">{{ shipping.awb }}</p>
          <div class="">
            <ul class="verti-timeline list-unstyled">
              <li
                :class="
                  index == orderTracking.length - 1
                    ? 'event-list active'
                    : 'event-list'
                "
                v-for="(ot, index) in orderTracking"
                :key="index"
              >
                <div class="event-timeline-dot">
                  <i
                    :class="
                      index == orderTracking.length - 1
                        ? 'fa basicOrder fa-arrow-circle-o-right animatedXfade'
                        : 'fa fa-arrow-circle-o-right text-muted'
                    "
                  ></i>
                </div>
                <div class="media">
                  <div class="me-3 mb-3 mt-1">
                    <!-- <i
                      :class="
                        ot.title == 'Pesanan Baru'
                          ? 'fa h4-icon fa-copy text-primary'
                          : ot.title == 'Diproses'
                          ? 'fa h4-icon fa-truck-loading text-primary'
                          : ot.title == 'Dikirim'
                          ? 'fa h4-icon fa-shipping-fast text-primary'
                          : ot.title == 'Sampai'
                          ? 'fa h4-icon fa-map-marker-alt text-primary'
                          : ot.title == 'Diterima'
                          ? 'fa h4-icon fa-clipboard-check text-primary'
                          : 'fab h4-icon fa-buffer text-primary'
                      "
                    ></i> -->
                  </div>
                  <div class="media-body">
                    <div>
                      <h5>
                        {{
                          ot.status
                            .toLowerCase()
                            .split(" ")
                            .map(
                              (s) => s.charAt(0).toUpperCase() + s.substring(1)
                            )
                            .join(" ")
                        }}
                      </h5>
                      <p class="text-muted fs-13">
                        {{
                          ot.status_stage
                            .toLowerCase()
                            .split("_")
                            .map(
                              (s) => s.charAt(0).toUpperCase() + s.substring(1)
                            )
                            .join(" ")
                        }}
                      </p>
                      <span class="text-muted fs-13">Hari: {{ ot.time }}</span>
                      <br />
                      <!-- <span class="text-muted fs-13">Jam: {{ ot.time }}</span> -->
                    </div>
                  </div>
                </div>
              </li>
              <li class="event-list" v-if="statusDibatalkan.isActive">
                <div class="event-timeline-dot">
                  <i
                    id="canceledOrder"
                    class="fa fa-arrow-circle-o-right text-muted"
                  ></i>
                </div>
                <div class="media">
                  <div class="me-3 mb-3 mt-1">
                    <i
                      class="
                        fa
                        h4-icon
                        fa-times-circle
                        v-timeline-icon v-last
                        text-danger
                      "
                    ></i>
                  </div>
                  <div class="media-body">
                    <div>
                      <h5>{{ statusDibatalkan.title }}!</h5>
                      <p class="text-muted fs-13">
                        {{ statusDibatalkan.subTitle }}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </template>
        <!-- <li>Order Tracking 1</li>
          <li>Order Tracking 2</li>
          <li>Order Tracking 3</li> -->
      </div>
    </div>
  </main>
</template>

<script>
// import $ from "jquery";
export default {
  props: {
    orderTimeline: {},
    statusDibatalkan: {},
    shipping: {},
    orderTracking: [],
    isTracking: Boolean,
    isOpenTracking: Boolean,
    isFetching: Boolean,
    openTracking: { type: Function },
    rejectReason: String,
  },
  created() {
    // Melakukan console.log pada prop orderTimeline saat komponen dibuat
    console.log("orderTimeline:", this.orderTimeline);
  },
  mounted() {
    // Melakukan console.log pada prop orderTimeline saat komponen dipasang ke DOM
    console.log(
      "Komponen telah dipasang dengan orderTimeline:",
      this.orderTimeline
    );
  },
};
</script>

<style scoped>
.fs-13 {
  font-size: 13px;
}
.h4-icon {
  font-size: 20px;
}
.verti-timeline {
  border-left: 3px dashed #f6f6f6;
  margin: 0 10px;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.verti-timeline .event-list {
  position: relative;
  padding: 0 0 40px 28px;
}

.list-unstyled {
  list-style: none;
}

.verti-timeline .event-list .event-timeline-dot {
  position: absolute;
  left: -9px;
  top: 0;
  z-index: 9;
  font-size: 16px;
}

.media {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.me-3 {
  margin-right: 1rem !important;
}

.media-body {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.verti-timeline .event-list.active .event-timeline-dot {
  color: #556ee6;
}

.verti-timeline .event-list .event-timeline-dot {
  position: absolute;
  left: -9px;
  top: 0;
  z-index: 9;
  font-size: 16px;
}
</style>
